import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { updateOrganization as updateOrganizationAction } from 'data/organizations/actions'
import { hasSSOEnabled } from 'data/organizations/selectors'

import Layout from './Layout'
import useOrganizationField from '../hooks/useOrganizationField'

export default function SettingsOrganizationInformationsJoin() {
  const organizationDomain = useOrganizationField('domain')
  const organizationAuthDomains = useOrganizationField('authDomains')
  const canAutoJoin = useOrganizationField('membersCanAutoJoin')
  const organizationHasSSO = useSelector(hasSSOEnabled)

  const dispatch = useDispatch()
  const updateOrganization = React.useCallback(
    params => dispatch(updateOrganizationAction(params)),
    [dispatch]
  )

  return (
    <Layout
      organizationDomain={organizationDomain}
      organizationMembersCanAutoJoin={canAutoJoin}
      organizationAuthDomains={organizationAuthDomains}
      organizationHasSSO={organizationHasSSO}
      updateOrganization={updateOrganization}
    />
  )
}
